import { TableProps } from 'antd/es/table';

import { Status } from '@Components/Base';

export const mapColumns: TableProps['columns'] = [
  {
    title: 'REQUEST NO.',
    dataIndex: 'requestNo',
    key: 'requestId',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'EMPLOYEE NUMBER',
    dataIndex: 'empNumber',
    key: 'empNumber',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'EMP NAME',
    dataIndex: 'empName',
    key: 'empName',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'TRAVEL DATE',
    dataIndex: 'travelDate',
    key: 'travelDate',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'RETURN DATE',
    dataIndex: 'returnDate',
    key: 'returnDate',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'PLACE OF TRAVEL',
    dataIndex: 'destination',
    key: 'destination',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'COUNTRY',
    dataIndex: 'country',
    key: 'leaveTypeID',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'CURRENT LOCATION',
    dataIndex: 'currentLocation',
    key: 'currentLocation',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'TOTAL DAYS',
    dataIndex: 'totDays',
    key: 'totDays',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'CREATED BY',
    dataIndex: 'createdBy',
    key: 'createdBy',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'CREATED DATE',
    dataIndex: 'createdDate',
    key: 'createdDate',
    sorter: true,
    ellipsis: true,
  },

  {
    title: 'APPROVER NAME',
    dataIndex: 'approverName',
    key: 'approverName',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'STATUS',
    dataIndex: 'status',
    key: 'reqStatusId',
    sorter: true,
    render: (text) => <Status text={text} />,
  },
];
